import React, { ChangeEvent } from 'react';
import { SearchInput } from '../../../../common/components/SearchInput/SearchInput';
import CompanyModel from '@mm/state/model/CompanyModel';
import { useResolutionInfo } from '@mm/hooks';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { useViewActions } from '@mm/state/actions/viewActions';
import { useSelector } from 'react-redux';
import { isFacebookUserSelector } from '@mm/state/selectors/userSelector';

type ConnectPagesButtonProps = {
  selectedCompany: CompanyModel;
  openConnectPagesModal: (company: CompanyModel) => void;
};

type Props = {
  searchInput: string;
  setSearchInput: (searchInput: string) => void;
} & ConnectPagesButtonProps;

export const ConnectBusinessButton = ({
  selectedCompany,
}: Pick<ConnectPagesButtonProps, 'selectedCompany'>) => {
  const viewActions = useViewActions();

  if (!selectedCompany.editable) {
    return <></>;
  }

  const onConnectBtnClick = () => {
    viewActions.showSlideoutMenu('businessForm', {
      company: selectedCompany,
    });
  };

  return (
    <PrimaryButton
      className="page-selector-pane__connect-pages-button"
      onClick={onConnectBtnClick}
    >
      Connect Accounts
    </PrimaryButton>
  );
};

const ConnectPagesButton = ({
  selectedCompany,
  openConnectPagesModal,
}: ConnectPagesButtonProps) => {
  const isFacebookUser = useSelector(isFacebookUserSelector);

  if (selectedCompany.editable) {
    if (!isFacebookUser) {
      return <ConnectBusinessButton selectedCompany={selectedCompany} />;
    }

    return (
      <PrimaryButton
        className="page-selector-pane__connect-pages-button"
        onClick={() => openConnectPagesModal(selectedCompany)}
      >
        Connect Accounts
      </PrimaryButton>
    );
  }

  return null;
};

const PagesListHeader = (props: Props) => {
  const {
    searchInput,
    setSearchInput,
    selectedCompany,
    openConnectPagesModal,
  } = props;
  const { isMobile } = useResolutionInfo();

  const onSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setSearchInput(e.target.value);
  };

  if (isMobile) {
    return (
      <>
        <div className="page-selector-pane__company-name">
          {selectedCompany.name}
        </div>
        <ConnectPagesButton
          selectedCompany={selectedCompany}
          openConnectPagesModal={openConnectPagesModal}
        />

        <SearchInput
          className="page-selector-pane__search-input"
          iconClassName="page-selector-pane__search-input-icon"
          value={searchInput}
          onChange={onSearchChange}
          placeholder="Search Accounts"
          hasBorder={true}
          useDarkStyle
        />
      </>
    );
  }

  return (
    <>
      <div className="page-selector-pane__company-name">
        {selectedCompany.name}
      </div>
      <ConnectPagesButton
        selectedCompany={selectedCompany}
        openConnectPagesModal={openConnectPagesModal}
      />
      <SearchInput
        className="page-selector-pane__search-input"
        value={searchInput}
        onChange={onSearchChange}
        placeholder="Search Facebook Accounts"
        inputClassName="page-selector-pane__search-input--input"
        useDarkStyle
      />
    </>
  );
};

export { PagesListHeader };
